import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CommonFormService {

  constructor() { }

  markFormGroupAsTouched(formGroup: FormGroup | FormArray): void {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
  
      if (control instanceof FormControl) {
        control.markAsTouched();
      } else if (control instanceof FormGroup) {
        this.markFormGroupAsTouched(control);
      } else if (control instanceof FormArray) {
        control.controls.forEach((groupOrControl) => {
          if (groupOrControl instanceof FormGroup || groupOrControl instanceof FormArray) {
            this.markFormGroupAsTouched(groupOrControl);
          } else {
            groupOrControl.markAsTouched();
          }
        });
      }
    });
  }
}
